// @ts-strict-ignore
export enum PermissionText {
  IsAdmin = 'is_admin',
  IsManager = 'is_manager',
  TwoWayMessaging = 'two_way_messaging'
}

export enum PermissionType {
  Read = 'read',
  ReadWrite = 'readWrite'
}
export interface Permission {
  id: number;

  name: PermissionText;

  type: PermissionType;
}
